import createBaseActions, { setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import { gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';

const {
  SET_IN_MAIL_DATA, SET_IN_MAIL_MODULS_DATA, SET_IN_MAIL_FRESH_DATA, SET_IN_MAIL_UNREAD_COUNT, UPDATA_IN_MAIL_READ_STATUS,
  ADD_IN_MAIL_DATA, UPATE_IN_MAIL_DATA_COUNT,
} = actionTypes;

export const setInmailData = createBaseActions(SET_IN_MAIL_DATA, 'data');
export const setInmailInFreshData = createBaseActions(SET_IN_MAIL_FRESH_DATA, 'data');
export const setInmailModulsData = createBaseActions(SET_IN_MAIL_MODULS_DATA, 'data');
export const setInmailUnreadCount = createBaseActions(SET_IN_MAIL_UNREAD_COUNT, 'data');
export const updateInmailReadStatuse = createBaseActions(UPDATA_IN_MAIL_READ_STATUS, 'data');
export const addInmailDataAction = createBaseActions(ADD_IN_MAIL_DATA, 'data');
export const updateInmailDataCountAction = createBaseActions(UPATE_IN_MAIL_DATA_COUNT, 'data');


export const fetchInmailData = (params, isFresh = false) => async (dispatch) => {
  const result = await gwPost(API_PATH.GET_IN_MAIL_DATA_API_PATH, setPostBody(params));
  if (isFresh) {
    dispatch(setInmailInFreshData(result));
  } else {
    dispatch(setInmailData(result));
  }
  return result;
};
export const addInmailData = (params) => async (dispatch) => {
  dispatch(addInmailDataAction(params));
};
export const updateInmailDataCount = (params) => async (dispatch) => {
  dispatch(updateInmailDataCountAction(params));
};

export const fetchInmailOneData = async (params) => {
  const result = await gwPost(API_PATH.GET_IN_MAIL_DATA_API_PATH, setPostBody(params));
  return result;
};

export const fetchInmailModules = (locale) => async (dispatch) => {
  const result = await gwPost(API_PATH.GET_IN_MAIL_MODULS_API_PATH, { locale });
  dispatch(setInmailModulsData(result.data));
};
export const fetchInmailReadOrDelet = async (data) => {
  const result = await gwPost(API_PATH.SET_IN_MAIL_READ_DELET_API_PATH, setPostBody(data));
  return result;
};
export const fetchInmailUnreadCount = () => async (dispatch) => {
  const result = await gwPost(API_PATH.SET_IN_MAIL_UNREAD_API_PATH);
  dispatch(setInmailUnreadCount(result.data));
};
export const fetchInmailStreamToken = async () => {
  const result = await gwPost(API_PATH.GET_IN_MAIL_STREAM_TOKEN_API_PATH);
  return result.data;
};
export const updateInmailReadStatus = (id) => async (dispatch) => {
  dispatch(updateInmailReadStatuse(id));
};

export default {};
